import type { RichTextNode } from "@/domain/Breeds/breeds.types";

export function formatDescription(descriptionField: RichTextNode[]): string {
  return descriptionField
    .map((node) => node.children.map((child) => child.text).join(""))
    .join("\n");
}
